import { render, staticRenderFns } from "./setMainAnalysis.vue?vue&type=template&id=0fbf3316&scoped=true&"
import script from "./setMainAnalysis.vue?vue&type=script&lang=js&"
export * from "./setMainAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./setMainAnalysis.vue?vue&type=style&index=0&id=0fbf3316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf3316",
  null
  
)

export default component.exports